<template>
    <div class="head-flex">
      <div class="logo">
        <img src="@/assets/images/logintitle.png" alt="">
      </div>
      <div class="head-nav">
        <div class="nav-item"
             v-for="item in headNav"
             :key="item.active"
             :class="{active:item.active == active}"
        @click="to(item)">
<!--          <img :src="item.icon" alt="">-->
          <i :class="item.iconfont"></i>
          <b>{{item.name}}</b>
        </div>
      </div>
      <div class="sign-out" @click="sginout">
        <img src="@/assets/images/yonghuicon.png" alt="">
        <p class="ovHide">{{user.username}}</p>
        <img src="@/assets/images/tuichu.png" alt="">
      </div>
      <contactUsDialog :dialogVisible="dialogVisible" @handleClose="handleClose" />
    </div>
</template>
<script>
import contactUsDialog from "@/views/home/common/contactUsDialog";
export default {
  name: "headP",
  data() {
    return {
      dialogVisible:false,
      headNav:[
        {
          name: '首页',
          icon: require('@/assets/images/shouye.png'),
          iconfont:'iconfont icon-shouye-copy',
          active: 1,
          page:'/home/index'
        },
        {
          name: '机构信息',
          icon: require('@/assets/images/jigouxinxi.png'),
          iconfont:'iconfont icon-gongsi',
          active: 2,
          page:'/home/orgDetail'
        },
        {
          name: '星级评定',
          icon: require('@/assets/images/xingjipingding.png'),
          iconfont:'iconfont icon-xingxing',
          active: 3,
          page:'/home/evaluateList'
        },
        {
          name: '风险预警',
          icon: require('@/assets/images/fengxianyujing.png'),
          iconfont:'iconfont icon-yujing',
          active: 4,
          page:'/home/riskList'
        },
        {
          name: '宣传信息',
          icon: require('@/assets/images/xuanchuanhuodong.png'),
          iconfont:'iconfont icon-xuanchuanhuodong-copy',
          active: 5,
          page:'/home/publicizeList'
        },
        {
          name: '下载中心',
          icon: require('@/assets/images/xiazaizhongxin.png'),
          iconfont:'iconfont icon-xiazai3',
          active: 6,
          page:'/home/downloadList'
        },
        {
          name: '联系我们',
          icon: require('@/assets/images/xiazaizhongxin.png'),
          iconfont:'iconfont icon-dianhua',
          active: 7,
          page:''
        }
      ]
    }
  },
  props:{
    active:{
      type: [String, Number],
      default: 1
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {contactUsDialog},
  created() {

  },
  methods: {
    // 跳转
    to(item) {
      if(item.active == 7) {
        this.dialogVisible = true
      } else {
        this.$router.replace(item.page)
      }
    },

    handleClose(){
      this.dialogVisible = false
    },

    sginout() {
      this.$confirm(
          '您确定要退出吗？',
          '温馨提示', {
            confirmButtonText: '确定',
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/login')
        })
      })
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.head-flex {
  width: 100%;
  height: 173px;
  background: url("../../../assets/images/headerbgc.png");
  display: flex;
  justify-content: space-between;
  align-items: center;
  .sign-out {
    position: absolute;
    right: 0;
    top: 0;
    width: 170px;
    //padding: 0 10px;
    height: 41px;
    background-color: rgba(255,255,255,.22);
    border-radius: 0 0 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    padding-right: 8px;
    margin-right: 20px;
    cursor: pointer;
    p {
      flex: 1;
      width: 0;
      padding: 0 5px;
      font-size: 18px;
      color: #ffffff;
      padding-right: 8px;
    }
  }
  .head-nav {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;
    .nav-item {
      width: max-content;
      height: 40px;
      margin-left: 2px;
      border-radius: 6px;
      padding-left: 5px;
      padding-right: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 21px;
        color: #ffffff;
        margin-right: 5px;
        margin-left: 2px;
      }
      b {
        font-size: 18px;
        color: #ffffff;
        font-weight: normal;
      }
      &.active {
        background-color: rgba(255,255,255,.22);
        b {
          font-weight: bold;
        }
      }
    }
  }
  .logo {
    img {
      margin: 0 38px;
    }
  }
}
</style>


